let config = { // eslint-disable-line
  URL_PREFIX: '/content',
};

export default config;

export function add(con) {
  config = Object.assign(config, con);
}
